import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

function LegacyRouteRedirect({ from, to, oauthTo }) {
  const { pathname, search, hash } = useLocation();
  const suffix = pathname.startsWith(from) ? pathname.slice(from.length) : '';
  const oauthParams = new URLSearchParams(search);
  const hasOAuthResult = oauthParams.has('code') || oauthParams.has('error') || oauthParams.has('service');
  const destination = oauthTo && hasOAuthResult ? oauthTo : to;
  return <Navigate replace to={`${destination}${suffix}${search}${hash}`} />;
}

export default LegacyRouteRedirect;
